const SESSION_ENTERED_VIA_FORCE_LOGIN = "sessionEnteredViaForceLogin";

/**
 * Tab-scoped flag (sessionStorage): only the tab that completed "Force login" sets this.
 * Avoids localStorage leaking across tabs on the same machine so device A is not treated as force-login.
 */
export function setSessionEnteredViaForceLogin() {
  try {
    sessionStorage.setItem(SESSION_ENTERED_VIA_FORCE_LOGIN, "1");
  } catch (_e) {
    // ignore
  }
}

/** Call when this tab becomes the active session owner again (e.g. "Continue here" on takeover modal). */
export function clearSessionEnteredViaForceLogin() {
  try {
    sessionStorage.removeItem(SESSION_ENTERED_VIA_FORCE_LOGIN);
  } catch (_e) {
    // ignore
  }
}

/** True if this tab's session started via Force login on the login screen. */
export function hasSessionEnteredViaForceLogin() {
  try {
    return sessionStorage.getItem(SESSION_ENTERED_VIA_FORCE_LOGIN) === "1";
  } catch (_e) {
    return false;
  }
}
